var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3182 1.64516L12.3636 1.64516L12.3636 0.354839L10.3182 0.354838L10.3182 1.64516ZM12.3636 7.62757L10.3182 7.62757L10.3182 8.91789L12.3636 8.91789L12.3636 7.62757ZM4.63637 1.64516L6.45454 1.64516L6.45455 0.354838L4.63637 0.354838L4.63637 1.64516ZM6.45454 7.62757L4.63637 7.62757L4.63637 8.91789L6.45454 8.91789L6.45454 7.62757ZM1.64516 4.63636C1.64516 2.98437 2.98437 1.64516 4.63637 1.64516L4.63637 0.354838C2.27174 0.354838 0.354838 2.27174 0.354838 4.63636L1.64516 4.63636ZM0.354838 4.63636C0.354838 7.00099 2.27174 8.91789 4.63637 8.91789L4.63637 7.62757C2.98437 7.62757 1.64516 6.28836 1.64516 4.63636L0.354838 4.63636ZM15.3548 4.63636C15.3548 6.28836 14.0156 7.62757 12.3636 7.62757L12.3636 8.91789C14.7283 8.91789 16.6452 7.00099 16.6452 4.63636L15.3548 4.63636ZM16.6452 4.63636C16.6452 2.27174 14.7283 0.354839 12.3636 0.354839L12.3636 1.64516C14.0156 1.64516 15.3548 2.98437 15.3548 4.63636L16.6452 4.63636Z",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5938 4.63867L4.6392 4.63867",
    stroke: "#989898",
    strokeWidth: 1.29032,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlIcon);
export default __webpack_public_path__ + "static/media/url-icon.c9d7b92a5be9c2f97fbf852017bad71a.svg";
export { ForwardRef as ReactComponent };